// extracted by mini-css-extract-plugin
export default {"container":"uJnTc9i1JYYEcqaCnonJ","questionText":"UQOGtwSFkFw2AasD_4CQ","activeButton":"b6S7MDyT844lf9YtfsmX","textArea":"SzKy6AiY14UBlA5rbHYq"};